import React, { Component } from 'react'
import { Container, Row, Col } from 'reactstrap'
import styled from 'styled-components'
import { fontWeight } from 'themes/font'
import Clearfix from 'components/elements/clearfix'
import Video from './video'
import Section from './section'
import PositionModal from './position-modal'
import Link from 'components/elements/link'
import ApplyNowBottom from './apply-now-bottom'
import Mentors from './mentors'
import { media } from 'styled-bootstrap-grid'
import Positions from './positions'

const Banner = styled.img`
  width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 8px 8px rgba(0,0,0,.05);
`

const Image = styled.img`
  width: 100%;
  height: auto;
`

const LearnMore = styled.div`
  display: flex;
  flex-direction: column;
  margin: -8px;
  .item {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 80px;
    margin: 8px;
    background: #F2FAF8;
    font-weight: ${fontWeight.bold};
    color: #4a4a4a;
  }
  ${media.lg`
    flex-direction: row;
    .item {
      flex: 1;
    }
  `}
`

class Career2 extends Component {
  state = {
    modalTitle: 'Title',
    modalBody: 'Body'
  }

  renderModalBody = (position) => {
    return (
      <div>
        <strong>Yêu cầu cho vị trí</strong>
        <Clearfix height={16} />
        <ul>
          {position.requirements.map((requirement, index) => (
            <li key={index}>{requirement}</li>
          ))}
        </ul>
      </div>
    )
  }

  handleClickPosition = (position) => () => {
    this.setState({
      modalTitle: position.title,
      modalBody: this.renderModalBody(position)
    }, () => {
      this.positionModal.toggle()
    })
  }

  render () {
    return (
      <Container>
        <Banner src={'/img/internship/banner.png'} className='animated fadeIn' />
        <Clearfix height={16} />
        <Section
          heading={'Tại sao bạn phải tham gia?'}
          style={{
            backgroundImage: 'linear-gradient(rgb(255, 251, 251) 0%, rgb(241, 245, 255) 57%)'
          }}
        >
          <p>Là một sinh viên sắp ra trường, chắc hẳn các bạn đang luôn băn khoăn về con đường nghề nghiệp của mình trong tương lai. Nếu bạn đang là sinh viên năm cuối đại học, có khao khát được tìm hiểu và phát triển chuyên môn trong một lĩnh vực cụ thể nhưng không thể tìm được một chương trình:</p>
          <ul>
            <li>Giúp các bạn có thể tham gia trực tiếp vào các project của các công ty theo nguyên tắc: thực làm – thực học – áp dụng trực tiếp những kiến thức được học vào thực tế và học được kiến thức thực tế từ những gì đang làm! </li>
            <li>Hiểu được cụ thể và rõ ràng về bản chất của một công việc, lộ trình cụ thể của một nghề nghiệp thông qua hướng dẫn của đội ngũ coach/mentor nhiều kinh nghiệm.</li>
            <li>Được làm việc với một đội ngũ khởi nghiệp năng động, có năng lực và luôn khao khát đổi mới. Được tự chủ với công việc và tạo ra giá trị lớn bằng chính sản phẩm mình tạo ra.</li>
          </ul>
          <p>Nếu câu trả lời của bạn đều là CÓ cho 3 câu hỏi trên, đừng ngần ngại tham gia “Tungtung’s Internship Program 2019” của chúng tôi. <strong>Đặc biệt, các thực tập sinh xuất sắc sẽ được tuyển dụng vào các vị trí chính thức của Tungtung.</strong></p>
        </Section>
        <Section heading={'Các vị trí tuyển dụng & Lợi ích khi tham gia'}>
          <Row className='align-items-center'>
            <Col md={6}>
              <Positions onClick={this.handleClickPosition} />
            </Col>
            <Col md={6}>
              <ul style={{ paddingTop: 16, paddingBottom: 16, paddingLeft: 16 }}>
                <li>Học hỏi kiến thức thực tiễn khi tham gia vào các dự án thực tế của Tungtung với các hoạt động on-job-training và tổng kết liên tục hàng tuần.</li>
                <li>Được huấn luyện và tư vấn bởi đội ngũ coach/mentor giàu kinh nghiệm, chuyên môn. Đặc biệt, thực tập sinh sẽ được tham gia các buổi mentor 1-1.</li>
                <li>Tham gia các buổi training về kỹ năng mềm (kỹ năng thuyết trình, làm việc nhóm, tư duy phản biện, giải quyết vấn đề, quản lý thời gian,...).</li>
                <li>Học hỏi các hoạt động đặc trưng của một start-up (gọi vốn, business model,...).</li>
                <li>Được hỗ trợ chi phí xăng xe, điện thoại. Đặc biệt, Tungtung sẽ trao giải cho 2 thực tập sinh có thành tích tốt nhất trong kỳ thực tập.</li>
                <li>Được xem xét tuyển dụng vào vị trí chính thức nếu có kết quả công việc tốt.</li>
              </ul>
            </Col>
          </Row>
        </Section>
        <Section heading={'Lịch trình'}>
          <Image src='/img/internship/timeline.png' />
        </Section>
        <Section style={{ padding: 0 }}>
          <Image src='/img/internship/testimonials.png' />
        </Section>
        <Section heading={'Coach / Mentor'}>
          <Mentors />
        </Section>
        <Section heading={'Video giới thiệu tungtung'}>
          <Video data={'https://www.youtube.com/watch?time_continue=7&v=XviOR3RYUgg'} />
        </Section>
        <Section heading={'Tìm hiểu thêm về tungtung'}>
          <LearnMore>
            <Link className='item' to={'/about'}>About us</Link>
            <Link className='item' to={'/career'}>Career</Link>
            <Link className='item' to='(https://tungtung.vn)'>Trang chủ đề thi</Link>
          </LearnMore>
        </Section>
        <ApplyNowBottom />
        <PositionModal
          ref={ref => (this.positionModal = ref)}
          title={this.state.modalTitle}
          body={this.state.modalBody}
        />
      </Container>
    )
  }
}

export default Career2
